import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorState, LoadingState } from '../../components/ui/state';
import { api } from '../../shared/api';
import { DaycareForm, DaycareFormShell, daycareUpdatePayload } from './DaycareForm';

export function DaycareEditPage() {
  const { daycareId = '' } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const daycareQuery = useQuery({ queryKey: ['daycares', daycareId], queryFn: () => api.daycares.get(daycareId), enabled: Boolean(daycareId) });
  const dogsQuery = useQuery({ queryKey: ['dogs'], queryFn: () => api.dogs.listAll() });
  const servicesQuery = useQuery({ queryKey: ['services'], queryFn: api.services.list });
  const membershipsQuery = useQuery({ queryKey: ['membership-purchases', 'daycare'], queryFn: () => api.memberships.purchases({ limit: 100 }) });
  const updateDaycare = useMutation({
    mutationFn: (values: Parameters<typeof daycareUpdatePayload>[0]) => api.daycares.update(daycareId, daycareUpdatePayload(values)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['daycares'] });
      await queryClient.invalidateQueries({ queryKey: ['daycares', daycareId] });
      navigate('/admin/daycares');
    },
  });

  if (daycareQuery.isLoading || dogsQuery.isLoading || servicesQuery.isLoading || membershipsQuery.isLoading) return <LoadingState label="Cargando guardería" />;
  if (daycareQuery.isError) return <ErrorState message={daycareQuery.error.message} />;
  if (dogsQuery.isError) return <ErrorState message={dogsQuery.error.message} />;
  if (servicesQuery.isError) return <ErrorState message={servicesQuery.error.message} />;
  if (membershipsQuery.isError) return <ErrorState message={membershipsQuery.error.message} />;

  return (
    <DaycareFormShell title="Editar guardería">
      <DaycareForm
        initialValue={daycareQuery.data}
        lookups={{ dogs: dogsQuery.data?.items ?? [], services: servicesQuery.data?.items ?? [], memberships: membershipsQuery.data?.items ?? [] }}
        error={updateDaycare.error?.message}
        isSaving={updateDaycare.isPending}
        includeStatus
        submitLabel="Guardar guardería"
        onSubmit={(values) => updateDaycare.mutate(values)}
      />
    </DaycareFormShell>
  );
}
